import type {StateProvider} from '@uirouter/angularjs';
import SeekingService from './seeking.service';
import providedSeekingsTemplate from './provided-seekings.tpl.ftl';
import seekedSeekingsTemplate from './seeked-seekings.tpl.ftl';

/*@ngInject*/
export default function seekingsRoutes($stateProvider: StateProvider) {

    $stateProvider
        .state('seeked-seekings', {
            url: '/seeked-seekings',
            templateUrl: seekedSeekingsTemplate,
            controller: SeekingService,
            controllerAs: '$ctrl',
            resolve: {}
        })
        .state('provided-seekings', {
            url: '/provided-seekings',
            templateUrl: providedSeekingsTemplate,
            controller: SeekingService,
            controllerAs: '$ctrl',
            resolve: {}
        });
}